<template>
    <div>
        <div v-if="delete_loader" class="checkoutLoader">
            <div class="LoaderPlacement">
                <div class="digi-table-loader">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        </div>
        <div class="table-content mb-3" style="overflow-x: auto !important;">
            <table class="table table-content-data table-responsive" style="border: solid 0.5px #f2f3f5;border-radius: 8px;">
                <thead>
                    <tr>
                        <th class="whiteSpace w-1">
                            Work Shift
                        </th>
                        <!-- <th class="whiteSpace w-1">
                            Start Date
                        </th>
                        <th class="whiteSpace w-1">
                            End Date
                        </th> -->
                        <th class="whiteSpace w-1">
                            Start Time
                        </th>
                        <th class="whiteSpace w-1">
                            End Time
                        </th>
                        <th class="whiteSpace w-1">
                            Working <br>Hours
                        </th>
                        <th class="whiteSpace w-1">
                            Work Week
                        </th>
                        <th class="whiteSpace w-1">
                            MON
                        </th>
                        <th class="whiteSpace w-1">
                            TUE
                        </th>
                        <th class="whiteSpace w-1">
                            WED
                        </th>
                        <th class="whiteSpace w-1">
                            THUR
                        </th>
                        <th class="whiteSpace w-1">
                            FRI
                        </th>
                        <th class="whiteSpace w-1">
                            SAT
                        </th>
                        <th class="whiteSpace w-1">
                            SUN
                        </th>
                        <th class="whiteSpace w-1">

                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="ajax_call_in_progress" class="text-center font-weight-bold">
                        <td colspan="13">
                            <hollow-dots-spinner :animation-duration="1000" :dot-size="17" :dots-num="3" color="#00448f" class="text-center w-100 d-flex justify-content-center position-relative"/>
                        </td>
                    </tr>
                    <tr v-if="!ajax_call_in_progress && list_data.length == 0" class="text-center font-weight-bold ht-100px">
                        <td colspan="13" class="text-center">No Data Found</td>
                    </tr>
                    <tr v-else v-for="(data, index) in list_data" :key="index+'list_data'">
                        <td class="whiteSpace w-1 text-capitalize">
                            {{data.shift_name || "-"}}
                        </td>
                        <!-- <td class="whiteSpace w-1 ">
                            {{data.start_date || "-"}}
                        </td>
                        <td class="whiteSpace w-1 ">
                            {{data.end_date || "-"}}
                        </td> -->
                        <td v-if="data.start_time" class="whiteSpace w-1 ">
                            {{convertTime24To12(data.start_time)}}
                        </td>
                        <td v-else class="whiteSpace w-1 ">
                            -
                        </td>
                        <td v-if="data.end_time" class="whiteSpace w-1 ">
                            {{convertTime24To12(data.end_time)}}
                        </td>
                        <td v-else class="whiteSpace w-1 ">
                            -
                        </td>
                        <td class="whiteSpace w-1">
                            {{data.total_working_hours || "-"}}
                        </td>
                        <td class="whiteSpace w-1 text-capitalize">
                            {{data.default || "-"}}
                        </td>
                        <td class="whiteSpace w-1">
                            <span v-if="data.days_of_workshift.length > 0">
                                <span v-if="data.days_of_workshift.includes('Mon')">
                                    Y
                                </span>
                                <span v-else>
                                    N
                                </span>
                            </span>
                            <span v-else>-</span>
                        </td>
                        <td class="whiteSpace w-1">
                            <span v-if="data.days_of_workshift.length > 0">
                                <span v-if="data.days_of_workshift.includes('Tue')">
                                    Y
                                </span>
                                <span v-else>
                                    N
                                </span>
                            </span>
                            <span v-else>-</span>
                        </td>
                        <td class="whiteSpace w-1">
                            <span v-if="data.days_of_workshift.length > 0">
                                <span v-if="data.days_of_workshift.includes('Wed')">
                                    Y
                                </span>
                                <span v-else>
                                    N
                                </span>
                            </span>
                            <span v-else>-</span>
                        </td>
                        <td class="whiteSpace w-1">
                            <span v-if="data.days_of_workshift.length > 0">
                                <span v-if="data.days_of_workshift.includes('Thur')">
                                    Y
                                </span>
                                <span v-else>
                                    N
                                </span>
                            </span>
                            <span v-else>-</span>
                        </td>
                        <td class="whiteSpace w-1">
                            <span v-if="data.days_of_workshift.length > 0">
                                <span v-if="data.days_of_workshift.includes('Fri')">
                                    Y
                                </span>
                                <span v-else>
                                    N
                                </span>
                            </span>
                            <span v-else>-</span>
                        </td>
                        <td class="whiteSpace w-1">
                            <span v-if="data.days_of_workshift.length > 0">
                                <span v-if="data.days_of_workshift.includes('Sat')">
                                    Y
                                </span>
                                <span v-else>
                                    N
                                </span>
                            </span>
                            <span v-else>-</span>
                        </td>
                        <td class="whiteSpace w-1">
                            <span v-if="data.days_of_workshift.length > 0">
                                <span v-if="data.days_of_workshift.includes('Sun')">
                                    Y
                                </span>
                                <span v-else>
                                    N
                                </span>
                            </span>
                            <span v-else>-</span>
                        </td>
                        <td class="whiteSpace w-1">
                            <span class="pointer whiteSpace buttons action-btns-show-hide">
                                <button class="btn btn-icon actionicons view" style="height: 25px;padding: 5px !important;" @click="showEditModal(data._id)">
                                    <el-tooltip class="item" effect="dark" content="Edit" placement="top" style="bottom: 4.5px;">
                                        <i class="icon icon-pencil editIcon"></i>
                                    </el-tooltip>
                                </button>
                                <button class="btn btn-icon actionicons update ml-3" style="height: 25px;padding: 5px !important;" @click="deleteWorkShiftConfirm(data._id)">
                                    <el-tooltip class="item" effect="dark" content="Delete" placement="top" style="bottom: 4.5px;">
                                        <i class="icon icon-trash deleteIcon"></i>
                                    </el-tooltip>
                                </button>
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="d-flex align-items-center font-weight-bold mt-2 justify-content-end" v-if="total > 0">
            <multiselect class="diginew-multiselect dd-ht multiple-select-arrow-hide"
                :options="pageLimit" :close-on-select="true" v-model.number="limit"
                @search-change="fetchListData"
                open-direction="top" :show-labels="false" placeholder=""
                style="width: 5.3em !important;padding-right: 10px!important;"></multiselect>
            <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/down-arrow-grey.svg"
                style="margin-left: -35px;">
            <span class="page-info pr-2 pl-6 fw-500"
                style="height: 2.4rem;line-height: 2.4rem;color: #4e5764;font-size: 12px;">Per page</span>
            <button @click="firstPage()" :disabled="skip == 0" class="mt-1 pointer pagination-list">
                <el-tooltip class="item" effect="dark" content="First Page" placement="top">
                    <i class="icon-chevron-double-left"></i>
                </el-tooltip>
            </button>
            <button @click="previousPage()" :disabled="skip == 0" class="pagination-list mt-1 ml-2 pointer">
                <el-tooltip class="item" effect="dark" content="Previous Page" placement="top">
                    <i class="icon icon-chevron-left"></i>
                </el-tooltip>
            </button>
            <span class="px-2 fw-500 fs-14 mt-1">Showing {{getSkipCount}} - {{total>skip+limit?skip+limit:total}} of {{total}}</span>
            <button @click="nextPage()" :disabled="skip_temp >= total" class="pagination-list mt-1 mr-2 pointer">
                <el-tooltip class="item" effect="dark" content="Next Page" placement="top">
                    <i class="icon icon-chevron-right"></i>
                </el-tooltip>
            </button>
            <button @click="lastPage()" class="mt-1 pointer pagination-list" :disabled ="temp_total+10 >= total">
                <el-tooltip class="item" effect="dark" content="Last Page" placement="top">
                    <i class="icon-chevron-double-right"></i>
                </el-tooltip>
            </button>
        </div>
        <!-- <div>
            <div class="row">
                <div class="col-md-12">
                    <div class="float-right">
                        <span class="text-new-blue fs-14 pointer d-block" @click="showCreateModal">
                            + Add New Shift
                        </span>
                    </div>
                </div>
            </div>
        </div> -->
        <create-configure-shift-work v-if="create_modal" @saveSuccess="saveSuccess" @hideModal="hideCreateModal" :workshift_id="workshift_id" :mode="mode" modal_name="Create-Modal"></create-configure-shift-work>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>
<script>
const CreateConfigureShiftWork = () => import('./CreateConfigureShiftWork');
import facility_mgmt from '../../mixins/facility_mgmt.js';
import { SweetModal } from 'sweet-modal-vue';
import { EventBus } from '../../eventBus/nav-bar-event.js';
import time_utils from '../../mixins/time_utils.js';
import Swal from 'sweetalert2';
export default {
    mixins: [facility_mgmt, time_utils],
    components: {
        CreateConfigureShiftWork,
        SweetModal,
        Swal
    },
    data(){
        return{
            delete_loader: false,
            success_msg: '',
            warning_msg: '',
            create_modal: false,
            list_data: [],
            ajax_call_in_progress: false,
            mode: 'create',
            workshift_id: '',
            skip:0,
            limit:10,
            total:0,
            temp_total:0,
            search_key:'',
            pageLimit: [],
            skip_temp: 0,
            count:0,
            pageLimit: [],
        }
    },
    methods:{
        hideCreateModal() {
            this.create_modal = false;
            setTimeout(() => {
                this.$modal.hide('Create-Modal');
            }, 500);
        },
        showCreateModal() {
            this.mode = 'create';
            this.create_modal = true;
            setTimeout(() => {
                this.$modal.show('Create-Modal');
            }, 500);
        },
        showEditModal(id) {
            this.workshift_id = id;
            this.mode = 'edit';
            this.create_modal = true;
            setTimeout(() => {
                this.$modal.show('Create-Modal');
            }, 500);
        },
        firstPage(){
            this.temp_total = 0
            this.skip = 0
            this.limit = 10
            this.list_data = []
            this.getListData()
        },
        lastPage(){
            this.skip_temp = 0
            this.skip = 0
            this.temp_total = this.total
            let no_of_pages = Math.ceil(this.total/this.limit)
            this.skip_temp = (no_of_pages * this.limit) - this.limit
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp
            this.getListData();
        },
        nextPage() {
            this.skip_temp = this.skip + this.limit > this.total ? this.total : this.skip + this.limit;
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp;
            this.getListData();
        },
        previousPage() {
            this.skip_temp = 0
            this.temp_total = 0
            if (this.skip == 0) {
                return;
            }
            this.skip = this.skip - this.limit <= 0 ? 0 : this.skip - this.limit;
            this.getListData();
        },
        async getListData() {
            this.list_data = [];
            this.ajax_call_in_progress = true;
            try {
                let params = {
                    skip: this.skip,
                    limit: this.limit,
                    search_key: this.search_key.trim(),
                };
                let response = await this.getWorkShiftList(params);
                this.list_data = response.response.workshifts;
                this.total = response.response.count;
                this.$emit('work_data_length', this.total);
                this.ajax_call_in_progress = false;
            } catch (error) {
                this.warning_msg = error;
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
                this.ajax_call_in_progress = false;
            }
        },
        deleteWorkShiftConfirm(id){
            Swal.fire({
                title: 'Alert',
                text: "Are you sure want to delete ?",
                type: 'warning',
                icon: 'warning',
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonColor:'#00448b',
                confirmButtonText:'YES',
                cancelButtonText:'NO'
            }).then((result) => {
                if (result.isConfirmed == true) {
                    this.deleteWorkShift(id)
                }
            })
        },
        async deleteWorkShift(id) {
            this.delete_loader = true
            try {
                let params = {
                    workshift_id: id,
                }
                let response = await this.deleteWorkShiftById(params);
                this.success_msg = response.response.success_message
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.delete_loader = false
                    this.getListData();
                }, 3000);
            }
            catch (error) {
                this.delete_loader = false
                this.warning_msg = error;
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        },
        saveSuccess() {
            this.getListData();
        }
    },
    mounted() {
        for (let i = 10; i <= 50; i+=10) {
            this.pageLimit.push(i);
        }
        this.getListData();
        EventBus.$on('addWorkShift', () => {
            this.showCreateModal();
        });
    },
    watch: {
        limit: function(){
            this.getListData();
        }
    },
    computed: {
        getSkipCount(){
            if(this.total == 0) {
                return 0
            } else {
                let skip_count = this.skip>this.total?this.total:this.skip+1;
                return skip_count;
            }
        },
    }
}
</script>
<style scoped>
.ht-100px{
    height: 100px;
}
</style>